import useDevice from 'hooks/useDevice';
import React, { useState, useEffect, Suspense, lazy } from 'react';

const Landing = lazy(() => import('./Landing'));
const MobileLanding = lazy(() => import('./MobileLanding'));

const CallBackModal = lazy(() => import('../../components/common/CallBackModal'));

export default function LandingPage() {
  const { isMobile } = useDevice();
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const timer = window.setTimeout(() => {
      setShowModal(true);
    }, 10000); // 10 seconds

    return () => window.clearTimeout(timer);
  }, []);

  return (
    <>
      {showModal && (
        <Suspense fallback={null}>
          <CallBackModal
            showModal={showModal}
            setShowModal={setShowModal}
            isApp={false}
            isGallery={false}
            image={null}
          />
        </Suspense>
      )}
      <Suspense fallback={null}>{isMobile ? <MobileLanding /> : <Landing />}</Suspense>
    </>
  );
}
